// extracted by mini-css-extract-plugin
module.exports = {"container":"IndentedExpandHandle__container--a6","expandHandleContainer":"IndentedExpandHandle__expandHandleContainer--HD","icon":"IndentedExpandHandle__icon--Wn"};